(() => {
  if (customElements.get('crewford-zones')) return;
  customElements.define('crewford-zones', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.buttons = Array.from(this.querySelectorAll('[data-cf-zone]'));
      this.tabs = this.buttons.filter(button => button.getAttribute('role') === 'tab');
      this.panels = Array.from(this.querySelectorAll('[data-cf-zone-panel]'));
      this.shapes = Array.from(this.querySelectorAll('[data-cf-zone-shape]'));
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-cf-zone]');
        if (button && this.contains(button)) this.select(button.dataset.cfZone);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.tabs.includes(tab)) return;
        const index = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(this.tabs[next].dataset.cfZone);
        this.tabs[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const section = this.closest('.shopify-section');
        if (section && event.target.closest?.('.shopify-section') === section) this.select(event.detail?.blockId);
      }, options);
      this.select(this.dataset.activeZone || this.tabs[0]?.dataset.cfZone);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.buttons = this.tabs = this.panels = this.shapes = null;
    }
    select(id) {
      if (!id || !this.panels?.some(panel => panel.dataset.cfZonePanel === id)) return;
      this.dataset.activeZone = id;
      this.buttons.forEach(button => {
        const selected = button.dataset.cfZone === id;
        if (button.getAttribute('role') === 'tab') {
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
        } else button.setAttribute('aria-pressed', String(selected));
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.cfZonePanel !== id; });
      this.shapes.forEach(shape => { shape.toggleAttribute('hidden', shape.dataset.cfZoneShape !== id); });
    }
  });
})();
